<template>
    <div class="marquee-container">
      <div class="marquee-content" :style="{ animationDuration: duration + 's' }">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { Options, Vue, prop } from 'vue-class-component';
  
  class Props {
    duration = prop<number>({ default: 20 }); // 默认动画持续时间为20秒
  }
  
  @Options({})
  export default class MarqueeBox extends Vue.with(Props) {}
  </script>
  
  <style scoped>
  .marquee-container {
    overflow: hidden;
    white-space: nowrap;
    border-radius: 10px; /* 圆角 */
    background-color: white;
    border: 1px solid white;
    margin: 10px;
    padding: 10px;
  }
  
  .marquee-content {
    display: inline-block;
    padding-left: 100%;
    animation: marquee linear infinite;
  }
  
  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  </style>